// src/services/cotizacionService.js

import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL; // del .env
const API_URL = `${API_BASE}/api/cotizaciones`;
//const API_URL = "https://localhost:7169/api/cotizaciones";

// Listado paginado (solo encabezados)
export const obtenerCotizaciones = (
  page = 1,
  pageSize = 20,
  search = "",
  filtroFacturar,
  clavUsr = null,
  anio = null,
  mes = null,
) => {
  return axios.get(`${API_URL}/list`, {
    params: {
      page,
      pageSize,
      search: search || null,
      estado:
        ["FACTURADAS", "PENDIENTES", "SOLO_COTIZADAS"].includes(filtroFacturar)
          ? filtroFacturar
          : undefined,
      anio: anio && anio !== "TODOS" ? anio : undefined,
      mes: mes && mes !== "TODOS" ? mes : undefined,
      clavUsr: clavUsr || undefined,
    },
  });
};

// Una cotización con detalles
export const obtenerCotizacion = (id) => {
  return axios.get(`${API_URL}/${id}`);
};

// Crear cotización (maestro o completa con /crear)
export const crearCotizacion = (cotizacion) => {
  return axios.post(API_URL, cotizacion);
};

export const crearCotizacionCompleta = (payload) =>
  axios.post(`${API_URL}/crear`, payload);

// ✅ ACTUALIZAR cotización (nuevo endpoint de edición)
export const actualizarCotizacion = (id, payload) => {
  // Antes: PUT /api/cotizaciones/{id}
  // Ahora: PUT /api/cotizaciones/{id}/actualizar  (recalcula y sincroniza detalle)
  return axios.put(`${API_URL}/${id}/actualizar`, payload);
};

// Duplicar cotización (crea una nueva con el siguiente consecutivo)
export const duplicarCotizacion = (id) => {
  return axios.post(`${API_URL}/${id}/duplicar`);
};

// Sincronizar artículos de la cotización al catálogo de artículos
export const sincronizarCatalogo = (id, empresaId) => {
  return axios.post(`${API_URL}/${id}/sincronizar-catalogo`, null, {
    params: { empresaId },
  });
};

// Eliminar cotización
export const eliminarCotizacion = (id) => {
  return axios.delete(`${API_URL}/${id}`);
};

// Enviar cotización por correo electrónico
export const enviarCorreoCotizacion = (id, payload) => {
  return axios.post(`${API_URL}/${id}/enviar-correo`, payload);
};

// Agregar renglón de detalle (si lo usas suelto)
export const crearDetalleCotizacion = (detalle) => {
  return axios.post(`${API_URL}/detalle`, detalle);
};

// 🔎 Busca cliente por clave (si este endpoint no vive en cotizaciones,
// muévelo al service correspondiente; aquí lo dejo como lo tienes)
export async function buscarClientePorClave(empresaId, clave) {
  try {
    const { data } = await axios.get(`${API_URL}/by-clave`, {
      params: { empresaId, clave },
    });
    return data; // { id, cliente, razonSocial, ... }
  } catch (e) {
    if (e.response && e.response.status === 404) return null;
    throw e;
  }
}
